import { Grid } from "@mui/material";
import MDBox from "components/MDBox";

import { FormTitle, Text } from "ui-components/Form";

function ChangePasswordInfo({ formRender, control, errors }) {
  return (
    <MDBox>
      <FormTitle title={"Change User Password"} />
      <MDBox mt={1.625}>
        {formRender.map((rows, i) => (
          <Grid container spacing={3} key={i}>
            {rows.map((property, index) => {
              const { disabled, ...data } = property;
              const fieldProps = {
                ...data,
                control,
                errors,
                ...(disabled && { disabled: true }),
              };

              return (
                <Grid item xs={12} key={index}>
                  <Text field={fieldProps} />
                </Grid>
              );
            })}
          </Grid>
        ))}
      </MDBox>
    </MDBox>
  );
}

export default ChangePasswordInfo;
